import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import ScrollToTop from './components/base/ScrollToTop';
import AudioPlayer from './components/feature/AudioPlayer';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ScrollToTop />
      <AudioPlayer />
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;